import { render } from "./EditFooter.vue?vue&type=template&id=bce6061a"
import script from "./EditFooter.vue?vue&type=script&lang=js"
export * from "./EditFooter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__